import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';

export const useIsCareDiscoveryEnabled = () => {
  const { data, isLoading } = useFeatureFlagQuery('care_discovery_enabled');

  return data || isLoading;
};
